import { Button, Intent, Size } from "@blueprintjs/core"
import { useState } from "react"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION, UPDATE_SINGLE_TYPE } from "src/modules/pe-basic-module/data/actionTypes"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../../landing-edit/utils/updateSection"
import { __, __cases, sprintf } from "src/libs/utilities"
import { ConfirmButton } from "src/libs/useful"

/* Protopia Ecosystem component */
export interface IExternalUpdateHandlerProps {
    primitive: LinksFeedContent
    section?: ILandingSection
}
const ExternalUpdateHandler = ({primitive, ...props}: IExternalUpdateHandlerProps): JSX.Element => {
    const currentLanding: ILanding      = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const [ isExternalUpdate, setIsExternalUpdate ] = useState<boolean>( false ) 
    const [ i, setI ]                               = useState<number>( 0 ) 
    const [ count, setCount ]                       = useState<number>( 0 ) 

    const onExternalUpdateAll = () => {
        setIsExternalUpdate( true ) 
        setCount( primitive.items.length  )
        const timer = setInterval(() => {
            setI( i => {
                console.log( i );                
                if( i > primitive.items.length - 1 ) {
                    clearInterval( timer )
                    setIsExternalUpdate( false )
                    return 0
                }
                else {
                    const item: any = {
                        ...primitive.items[ i ],
                        post_content: primitive.items[ i ].description,
                        post_status: primitive.items[ i ].status,
                        order: i,
                        rating: [], // primitive.items[ i ].rating || [],
                    }
                    delete item.status 
                    delete item.description

                    actions(
                        UPDATE_SINGLE_TYPE,
                        {
                            data_type: "PELink",
                            item 
                        }
                    )
                    
                    return i + 1 
                }
            });
            
        }, 3000, i)
    }
 
    const onExternalCategoriesUpdate = () => {
        setCount(currentLanding.categories!.length || 0) 
        const timer = setInterval(() => {
            setI( i => {
                console.log( i );                
                if( i > ( currentLanding.categories!.length || 0 ) - 1 ) {
                    clearInterval( timer ) 
                    return 0
                }
                else {
                    const cat = currentLanding.categories![ i ]
                    const item: any = {
                        ...cat,
                        content: cat.content,
                        slug: cat.id,
                        order: i,  
                    } 
                    delete item.type
                    delete item.id
                    actions(
                        UPDATE_SINGLE_TYPE,
                        {
                            data_type: "PELandingCategory",
                            item 
                        }
                    ) 
                    return i + 1 
                }
            });
            
        }, 3000, i)
    }
    const onExternalImportAll = () => {
        setIsExternalUpdate(true)
        actions(
            GET_FEED_ACTION,
            {
                data_type: "PELink",
                count: -1,
            }
        )
        .then(( res: any) => {
            setCount(res.count)
            let feed = res.feed.map((item:any) => {
                const link = {
                    ...item,
                    description: item.post_content ? item.post_content : item.description,
                    status: item.post_status ? item.post_status : item.status,
                }
                delete link.post_content
                delete link.post_status
                delete link.__typename
                return link
            })
            if( !!props.section) {
                const newSection = JSON.parse(JSON.stringify({
                    ...props.section,
                    data: props.section.data.map(meat => {
                        if(meat.id === primitive.id) {
                            return {
                                ...meat,
                                items: feed
                            }
                        }
                        return meat
                    }),
                }))
                updateSection(
                    newSection,
                    {
                        data: newSection,
                        prevData: props.section,
                        type: HISTORY_TYPE.SECTION,
                        title: "Update local links by external",    
                    } as IHistoryStep
                )
            }
            setIsExternalUpdate(false)
            // console.log( feed )            
        })
    }
    const onClearAllLocal = () => {
        if( !!props.section) {
            const newSection = JSON.parse(JSON.stringify({
                ...props.section,
                data: props.section.data.map(meat => {
                    if(meat.id === primitive.id) {
                        return {
                            ...meat,
                            items: []
                        }
                    }
                    return meat
                }),
            }))
            updateSection(
                newSection,
                {
                    data: newSection,
                    prevData: props.section,
                    type: HISTORY_TYPE.SECTION,
                    title: "Clear all local links",    
                } as IHistoryStep
            )
        }
    }
    const onExternalImportCategories = () => {

    }
    const is = 1
    return !!is
        ?
        <>
            <ConfirmButton 
                onConfirm={onExternalUpdateAll}
                buttonLabel={"External update all links"}
                buttonSmall
                buttonIntent={ Intent.PRIMARY }
                buttonClassName="ml-1"
                btnLabelName="smallest upper-case"
                data-select-type="ignore"
                buttonLoading={isExternalUpdate}
                confirm="Are you really want do this?"
                // size={ Size.SMALL } intent={ Intent.PRIMARY } className="ml-1" data-select-type="ignore" onClick={onExternalUpdateAll} loading={isExternalUpdate} 
            />

            <ConfirmButton 
                onConfirm={onExternalCategoriesUpdate}
                buttonLabel={"External update all categories"}
                buttonSmall
                buttonIntent={ Intent.PRIMARY }
                buttonClassName="ml-1"
                btnLabelName="smallest upper-case"
                data-select-type="ignore"
                buttonLoading={isExternalUpdate}
                confirm="Are you really want do this?"
                //</>size={ Size.SMALL } intent={ Intent.PRIMARY } className="ml-1" data-select-type="ignore" onClick={onExternalCategoriesUpdate} >
                //<div className="smaller">External update all categories</div>
            />

            <ConfirmButton 
                onConfirm={ onExternalImportAll }
                buttonLabel={"Import all external links"}
                buttonSmall
                buttonIntent={ Intent.SUCCESS }
                buttonClassName="ml-1"
                btnLabelName="smallest upper-case"
                data-select-type="ignore"
                buttonLoading={isExternalUpdate}
                confirm="Are you really want do this?"
                // size={ Size.SMALL } intent={ Intent.SUCCESS } className="ml-1" data-select-type="ignore" onClick={onExternalImportAll} loading={isExternalUpdate} >
                //<div className="smaller">Import all external links</div>
            />

            <ConfirmButton 
                onConfirm={ onExternalImportCategories }
                buttonLabel={"Import all external categories"}
                buttonSmall
                buttonIntent={ Intent.SUCCESS }
                buttonClassName="ml-1"
                btnLabelName="smallest upper-case"
                data-select-type="ignore"
                buttonLoading={isExternalUpdate}
                confirm="Are you really want do this?"
                // size={ Size.SMALL } intent={ Intent.SUCCESS } className="ml-1" data-select-type="ignore" onClick={onExternalImportAll} loading={isExternalUpdate} >
                //<div className="smaller">Import all external links</div>
            />

            <ConfirmButton 
                onConfirm={ onClearAllLocal }
                buttonLabel={ "Clear all local links" }
                buttonSmall
                buttonIntent={ Intent.DANGER }
                buttonClassName="ml-1"
                btnLabelName="smallest upper-case"
                data-select-type="ignore"
                buttonLoading={isExternalUpdate}
                confirm="Are you really want do this?"
                // size={ Size.SMALL } intent={ Intent.DANGER } className="ml-1" data-select-type="ignore" onClick={onClearAllLocal} loading={isExternalUpdate} >
                //<div className="smaller">Clear all local links</div>
            />
             
            {
                !!count && <div className=" smallest mt-1">
                    { 
                        sprintf( 
                            __cases(i, "Processed %s elements from %s"), 
                            i.toString(), 
                            count.toString() ) 
                    }
                </div>
            }
        </>
        :
        <></>
}
export default ExternalUpdateHandler